import { render, staticRenderFns } from "./StructureHoverTooltip.vue?vue&type=template&id=0aa07a67&scoped=true"
import script from "./StructureHoverTooltip.vue?vue&type=script&lang=js"
export * from "./StructureHoverTooltip.vue?vue&type=script&lang=js"
import style0 from "./StructureHoverTooltip.vue?vue&type=style&index=0&id=0aa07a67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa07a67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VFadeTransition})
